const whitespace = {
  lineBreaks: true,
  match: /\s+/,
}

export default whitespace
